import React from 'react';

import { SubscribeSreen } from '../../components';

const SubscriptionContainer = () => {
  return <SubscribeSreen></SubscribeSreen>;
};

export default SubscriptionContainer;
